export const iconFontAwesomeMoneyGgCircle = (
	<i className="fa-solid fa-gg-circle"></i>
);
